import { render, staticRenderFns } from "./HuaxianBannerLink.vue?vue&type=template&id=9a45d6f8&scoped=true&"
import script from "./HuaxianBannerLink.vue?vue&type=script&lang=js&"
export * from "./HuaxianBannerLink.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianBannerLink.vue?vue&type=style&index=0&id=9a45d6f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a45d6f8",
  null
  
)

export default component.exports